import { render, staticRenderFns } from "./SendResetPasswordLink.vue?vue&type=template&id=a002c39a"
import script from "./SendResetPasswordLink.vue?vue&type=script&lang=js"
export * from "./SendResetPasswordLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports